export default "__VITE_ASSET__bd82ac00__"